import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { AppSettings } from '../../proyect.conf';
import { map } from 'rxjs/operators';
import { ReglasNegocioVinculacion } from '../_models/reglas-negocio-vinculacion';



@Injectable({
  providedIn: 'root'
})
export class ReglasNegocioVinculacionService {
  private masterService = AppSettings.rutServiciosAPL + '/api/reglasNegocioVinculacion';

  constructor(private authHttp: HttpClient, private autServicio: AutenticacionService) { }

  getAll() {
    return this.authHttp.get( this.masterService )
      .pipe( map( res => res as ReglasNegocioVinculacion[] ) );
  }

  getById(idReglaNegocioVinculacion: string) {
    return this.authHttp.get( `${this.masterService}/${idReglaNegocioVinculacion}` )
      .pipe( map( res => res as ReglasNegocioVinculacion ) );
  }

  getAllEnabled() {
    return this.authHttp.get( `${this.masterService }/enabled`)
      .pipe( map( res => res as ReglasNegocioVinculacion[] ) );
  }

  add(f: ReglasNegocioVinculacion) {
    f.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.authHttp.post( this.masterService, f )
      .pipe( map( res => res as ReglasNegocioVinculacion ) );
  }

  update(f: ReglasNegocioVinculacion) {
    f.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.authHttp.put( this.masterService, f )
      .pipe( map( res => res as ReglasNegocioVinculacion ) );
  }
}
